export enum PagesEnums {
  Employees = "Employees",
  Tests = "Tests",
  Lendings = "Lendings",
  SMM = 'SMM'
}
